/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MdmPreviewEntitySearchHitDto } from './MdmPreviewEntitySearchHitDto';
import {
    MdmPreviewEntitySearchHitDtoFromJSON,
    MdmPreviewEntitySearchHitDtoFromJSONTyped,
    MdmPreviewEntitySearchHitDtoToJSON,
    MdmPreviewEntitySearchHitDtoToJSONTyped,
} from './MdmPreviewEntitySearchHitDto';

/**
 * 
 * @export
 * @interface MdmPreviewEntitySearchResponse
 */
export interface MdmPreviewEntitySearchResponse {
    /**
     * 
     * @type {Array<MdmPreviewEntitySearchHitDto>}
     * @memberof MdmPreviewEntitySearchResponse
     */
    results?: Array<MdmPreviewEntitySearchHitDto>;
    /**
     * 
     * @type {number}
     * @memberof MdmPreviewEntitySearchResponse
     */
    limit?: number;
    /**
     * 
     * @type {string}
     * @memberof MdmPreviewEntitySearchResponse
     */
    query?: string;
}

/**
 * Check if a given object implements the MdmPreviewEntitySearchResponse interface.
 */
export function instanceOfMdmPreviewEntitySearchResponse(value: object): value is MdmPreviewEntitySearchResponse {
    return true;
}

export function MdmPreviewEntitySearchResponseFromJSON(json: any): MdmPreviewEntitySearchResponse {
    return MdmPreviewEntitySearchResponseFromJSONTyped(json, false);
}

export function MdmPreviewEntitySearchResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MdmPreviewEntitySearchResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'results': json['results'] == null ? undefined : ((json['results'] as Array<any>).map(MdmPreviewEntitySearchHitDtoFromJSON)),
        'limit': json['limit'] == null ? undefined : json['limit'],
        'query': json['query'] == null ? undefined : json['query'],
    };
}

export function MdmPreviewEntitySearchResponseToJSON(json: any): MdmPreviewEntitySearchResponse {
    return MdmPreviewEntitySearchResponseToJSONTyped(json, false);
}

export function MdmPreviewEntitySearchResponseToJSONTyped(value?: MdmPreviewEntitySearchResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'results': value['results'] == null ? undefined : ((value['results'] as Array<any>).map(MdmPreviewEntitySearchHitDtoToJSON)),
        'limit': value['limit'],
        'query': value['query'],
    };
}

